export const ctaHelper = (ctaValues) => {
    return {
      name: ctaValues[0],
      type: ctaValues[1],
      componentName: ctaValues[2],
      destination: ctaValues[3]
    }
  }

export const calculateDaysToTrip = (dateVal) => {
    if(!dateVal) return "";
    const curDate = new Date();
    const dateDiff : number = Math.abs(dateVal.getTime() - curDate.getTime())
    return Math.abs(Math.round(dateDiff/(1000*60*60*24))); 
}

export const convert_yyyymmdd_to_dd_mm_dddd = (dateVal) => {
    try {
        const year = dateVal.slice(0, 4);
        const month = dateVal.slice(4, 6);
        const day = dateVal.slice(6,);
        const ans = `${day}:${month}:${year}`;
        return ans;
    } catch (e) {
        return "";
    }
};

export const calculateDroppingDate = (dateString, depTime, arrTime) => {
    if(!dateString && !depTime && !arrTime) return "";
    let mydate;
    if(arrTime < depTime){
    mydate = new Date(dateString.split(':').reverse().join('-'));
    mydate.setDate(mydate.getDate() + 1);
    let mm = mydate.getMonth() + 1; // getMonth() is zero-based
    let dd = mydate.getDate();

    return [(dd>9 ? '' : '0') + dd,
            (mm>9 ? '' : '0') + mm,
            mydate.getFullYear(),
            ].join(':');
    }
    return dateString;
}

export const availableOffers = (promos) => {
    let offersString = "";
    if(promos && promos.length === 0) return '';
    promos?.map((promo) => {
      offersString = offersString + promo?.key + "|";
    })
    const offersStringNew = offersString.slice(0, -1) ;
    return offersStringNew
  }

export const countRtcBuses = (operators) => {
    let count = 0;
    operators && operators.map((bus) => {
        count+=bus.total_count;
    })
    return count;
}

export const seatNumberMethod = (selectedSeats) => {
    let seatNoString = "";
    if(selectedSeats && selectedSeats.length === 0) return '';
    selectedSeats?.map((seat)=>{
      seatNoString=seatNoString+seat?.seat+"|";
    })
    const seatNoStringNew = seatNoString.slice(0, -1) ;
    return seatNoStringNew
  }

  export const fareBreakupHelper = (fareBreakupList:Array<Object>, key:string) => {
    if(!fareBreakupList || fareBreakupList.length === 0) return '';
    const res = fareBreakupList.filter((type)=>type.k===key);
    if(res.length>0)return res[0].v;
    else return '';
  }

  export const allFiltersApplied = (selectedFilters={}) => {
    if(!selectedFilters) return '';
    let filterString = '';
    for(const [key, value] of Object.entries(selectedFilters)){
        if(key==='operator'){ 
            if(Object.keys(value).length !== 0){
            for(const [opid, opname] of Object.entries(value)){
                filterString+=(opname+'|')
            }
            continue;
        }
            else{
                continue;
            }
        }
        if(key === 'single_seat' && value === true){
            filterString+=('single_seat|')
        }
            
        value && Array.isArray(value) && value.map((item) => {
            filterString+=(item+'|')
        })
    }

    if(filterString.length===1){
        return filterString;
    }
    else{
        return filterString.slice(0, -1);
    }
  }
  